import { render, staticRenderFns } from "./GuidesOperate.vue?vue&type=template&id=c6a56156&scoped=true&"
import script from "./GuidesOperate.vue?vue&type=script&lang=js&"
export * from "./GuidesOperate.vue?vue&type=script&lang=js&"
import style0 from "./GuidesOperate.vue?vue&type=style&index=0&id=c6a56156&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a56156",
  null
  
)

export default component.exports